import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    wrapperMyLeadContactDetailsFields: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    containerItem: {
      display: "flex",
      flexDirection: "row",
      gap: "32px",
      minHeight: "61px",
      alignItems: "center",
    },
    containerTitle: {
      maxWidth: "280px",
      minWidth: "160px",
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "20px",
      color: theme.palette.text.secondary,
    },
    customInput: {
      maxWidth: "100% !important",
    },
    containerReferedTo: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
    containerAlertAgent: {
      width: "100%",
      border: `1px solid ${theme.palette.foreground.senary}`,
      display: "flex",
      flexDirection: "row",
      gap: "12px",
      borderRadius: "12px",
      padding: "16px",
      justifyContent: "flex-start",
      alignItems: "flex-start",
    },
    wrapperIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: `2px solid ${theme.palette.border.error}`,
      borderRadius: "9999px",
      padding: "2px",
    },
    containerIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: `2px solid ${theme.palette.border.error}`,
      borderRadius: "9999px",
      padding: "4px",
      width: "28px",
      height: "28px",
    },
    wrapperIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: `2px solid ${theme.palette.border.error}`,
      borderRadius: "9999px",
      width: "40px",
      height: "40px",
      padding: "4px",
    },
    subTitleAlert: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      color: theme.palette.text.tertiary,
    },
    titleAlert: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "20px",
      color: theme.palette.text.secondary,
    },
  };
});
